import React, { Component } from "react";
import { Button, Form, notification, Select, Space, Spin, Avatar, Modal, Radio, Tabs } from "antd";
import { FormattedMessage, injectIntl } from "react-intl";
import styled, { withTheme } from "styled-components";
import AppContext from "../../../AppContext";

const { TabPane } = Tabs;

class Preferences extends Component {
  static contextType = AppContext;

  prefsChange = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      editing: false,
      templates: null,
      showSingle: false,
      doc_pref_editing: false,
      language_editing: false,
    };
  }

  componentDidMount = () => {
    if (this.props.clients?.length === 1) {
      this.setState({ showSingle: true });
    }

    if (
      this.props.clients?.length > 0 &&
      this.props.user_prefs?.documentPreferences &&
      Object.keys(this.props.user_prefs?.documentPreferences).length > 0
    ) {
      this.mapPropsToRadioButtons();
    }
  };

  onSubmit = async () => {
    this.setState({ saving: true });
    var payload = {};
    if (this.state.doc_pref_editing) {
      payload["documentPreferences"] = {};
      if (this.state.showSingle) {
        for (let i = 0; i < this.props.clients?.length ?? 0; i++) {
          let temp = {};
          for (let j = 0; j < this.props.document_preferences?.length ?? 0; j++) {
            temp[this.props.document_preferences[j].value] =
              this.state[this.props.document_preferences[j].value] === false
                ? 0
                : this.state[this.props.document_preferences[j].value] === true
                ? 1
                : "";
          }
          payload["documentPreferences"][this.props.clients[i].client_info.client_uuid] = temp;
        }
      } else {
        for (let i = 0; i < this.props.clients?.length ?? 0; i++) {
          let temp = {};
          for (let j = 0; j < this.props.document_preferences?.length ?? 0; j++) {
            if (this.state?.[this.props.clients[i].client_info.client_id]) {
              temp[this.props.document_preferences[j].value] =
                this.state?.[this.props.clients[i].client_info.client_id]?.[
                  this.props.document_preferences[j].value
                ] === false
                  ? 0
                  : this.state?.[this.props.clients[i].client_info.client_id]?.[
                      this.props.document_preferences[j].value
                    ] === true
                  ? 1
                  : "";
            }
          }
          if (this.state?.[this.props.clients[i].client_info.client_id]) {
            payload["documentPreferences"][this.props.clients[i].client_info.client_uuid] = temp;
          }
        }
      }
    }

    if (this.state.language_editing) {
      payload["languagePreferences"] = { communication: this.state.language };
    }

    let success = (await this.props.changePreferences(payload)) ?? false;
    if (success) {
      notification.success({
        message: <div className="text-capitalize-first">{this.props.intl.formatMessage({ id: "success" })}</div>,
        duration: 5,
      });
      if (this.prefsChange.current?.resetFields) {
        this.prefsChange.current.resetFields();
      }

      // Need to refresh radio buttons after submit
      this.mapPropsToRadioButtons();
    } else {
      notification.error({
        message: <div className="text-capitalize-first">{this.props.intl.formatMessage({ id: "error" })}</div>,
        duration: 5,
      });
    }
    this.setState({
      saving: false,
      editing: false,
      templates: null,
      showSingle: this.props.clients?.length === 1,
      doc_pref_editing: false,
      language_editing: false,
    });
  };

  mapPropsToRadioButtons = () => {
    // Convert 1/0 values the API needs to true/false for radio buttons
    for (const [uuid, prefs] of Object.entries(this.props.user_prefs?.documentPreferences)) {
      const client = this.props.clients.find(item => item?.client_info?.client_uuid === uuid);
      if (client) {
        Object.keys(prefs).map(k => (prefs[k] = Boolean(prefs[k])));
        this.setState({ [client.client_info.client_id]: prefs });
      }
    }
  };

  getLanguages = () => {
    let options = [];
    options = this.context.getLanguages()?.map(lang => {
      return {
        label: <div className="text-capitalize-first">{lang.label[this.context.getSelectedLanguage()]}</div>,
        value: lang.value,
      };
    });
    return options;
  };

  handleLanguageChange = value => {
    if (!this.state.editing) {
      this.setState({ editing: true });
    }
    if (!this.state.language_editing) {
      this.setState({ language_editing: true });
    }
    this.setState({ language: value });
  };

  getInitialLanguage = () => {
    return this.props.user_prefs?.languagePreferences?.communication || this.context.getSelectedLanguage();
  };

  getPageOptions = () => {
    let options = [];
    if (this.props?.pages) {
      options = this.props.pages?.map(page => {
        return {
          label: (
            <div className="text-capitalize">
              {this.context.intlFormatData(page.attrs.iso_language, page.variable_key)}
            </div>
          ),
          value: page.variable_value.value,
        };
      });
    }
    return options;
  };

  getRadios = () => {
    var options = this.props.document_options
      ?.sort((a, b) => a?.attrs?.sort_order - b?.attrs?.sort_order)
      ?.map(option => {
        return (
          <Radio key={option.variable_uuid} value={option.variable_value.value} disabled>
            {this.context.intlFormatData(option.attrs.iso_language, option.variable_key)}
          </Radio>
        );
      });
    return options;
  };

  getDocumentPreferences = (single, client_uuid, client_id) => {
    let setPref = {};
    for (let i = 0; i < this.props.setPreferences.length ?? 0; i++) {
      if (this.props.setPreferences[i].root_uuid === client_uuid) {
        setPref = this.props.setPreferences[i];
      }
    }
    var preferences = this.props.document_preferences?.map(pref => {
      return (
        <div className={`radioContainer ${single ? "single" : ""}`} key={pref.value + client_id}>
          <div className="text-capitalize-first radioLabel">
            {pref.label[this.context.getSelectedLanguage().toLowerCase()]}
          </div>
          <Space>
            <Radio.Group
              name={pref.value}
              value={setPref[pref?.key]}
              onChange={e => {
                if (!this.state.editing) {
                  this.setState({ editing: true });
                }
                if (!this.state.doc_pref_editing) {
                  this.setState({ doc_pref_editing: true });
                }
                client_id
                  ? this.setState({
                      [client_id]: { ...(this.state?.[client_id] ?? null), [pref.value]: e?.target?.value ?? "" },
                    })
                  : this.setState({ [pref.value]: e?.target?.value ?? "" });
              }}
            >
              {this.getRadios()}
            </Radio.Group>
          </Space>
        </div>
      );
    });
    return (
      <Form.Item name={!single ? ["documents", client_id] : "documents"}>
        <Space direction="vertical">{preferences}</Space>
      </Form.Item>
    );
  };

  onCancel = () => {
    const { confirm } = Modal;
    const { intl } = this.props;
    confirm({
      width: 500,
      title: (
        <div className="text-capitalize-first">
          {intl.formatMessage({ id: "are you sure you want to cancel these changes?" })}
        </div>
      ),
      content: (
        <div className="text-capitalize-first">
          {intl.formatMessage({ id: "if you continue, changes will be lost." })}
        </div>
      ),
      okText: <div className="text-capitalize-first">{intl.formatMessage({ id: "yes" })}</div>,
      okButtonProps: { type: "primary" },
      cancelText: <div className="text-capitalize-first">{intl.formatMessage({ id: "no" })}</div>,
      cancelButtonProps: { type: "default" },
      onOk: async () => {
        if (this.prefsChange.current?.resetFields) {
          this.prefsChange.current.resetFields();
        }
        await this.setState({
          saving: false,
          editing: false,
          templates: null,
          showSingle: this.props.clients?.length === 1,
          doc_pref_editing: false,
        });
      },
    });
  };

  render() {
    return (
      <Wrapper>
        <Spin spinning={this.state.saving}>
          <Form
            ref={this.prefsChange}
            layout="vertical"
            onFieldsChange={() => this.setState({ editing: true })}
            requiredMark={false}
            initialValues={{ page: "Dashboard", language: this.getInitialLanguage(), document_mode: false }}
          >
            <div>
              <FormattedMessage id="View and update your email language preference below. Contact your advisor to update your document delivery preferences." />
            </div>
            <div className="stepHeader step1">
              <Avatar size="small" shape="circle">
                1
              </Avatar>
              <div className="text-capitalize">
                <FormattedMessage id="email language" />
              </div>
            </div>
            <Form.Item
              name="language"
              label={
                <span className="text-capitalize">
                  <FormattedMessage id="receive communications in" />
                </span>
              }
              className="form-item-style"
            >
              <Select options={this.getLanguages()} onChange={this.handleLanguageChange} />
            </Form.Item>

            <div className="stepHeader step2">
              <Avatar size="small" shape="circle">
                2
              </Avatar>
              <div className="text-capitalize">
                <FormattedMessage id="document delivery" />
              </div>
            </div>
            {this.props.clients?.length > 1 && (
              <Space size={77} className="accountsSpace">
                <div className="text-capitalize-first">
                  <FormattedMessage id="apply settings for all accounts?" />
                </div>
                <Form.Item name="document_mode" className="radioPadding">
                  <Radio.Group
                    name="allAccounts"
                    onChange={e => this.setState({ showSingle: e?.target?.value ?? false })}
                  >
                    {this.getRadios()}
                  </Radio.Group>
                </Form.Item>
              </Space>
            )}
            <div className="form-item-style">
              <div className="text-capitalize-first  ant-form-item-label">
                <FormattedMessage id="receive a paper copy?" />
              </div>
              {!this.state?.showSingle ? (
                <Tabs tabPosition="left" className="clientPreferencesTabs" onChange={this.handleTabChange}>
                  {this.props.clients?.length > 0
                    ? this.props.clients?.map((item, index) => (
                        <TabPane tab={item.client_info.client_id} key={index}>
                          {this.getDocumentPreferences(false, item.client_info.client_uuid, item.client_info.client_id)}
                        </TabPane>
                      ))
                    : null}
                </Tabs>
              ) : (
                this.getDocumentPreferences(true, this.props.clients[0]?.client_info.client_uuid)
              )}
            </div>

            <Form.Item className="lastItem form-item-style">
              <div></div>
              <Space direction="vertical">
                <Space align="end">
                  <Button disabled={!this.state.editing} onClick={this.onCancel}>
                    <div className="text-capitalize-first">
                      <FormattedMessage id="cancel" />
                    </div>
                  </Button>
                  <Button disabled={!this.state.editing} type="primary" onClick={this.onSubmit}>
                    <div className="text-capitalize-first">
                      <FormattedMessage id="update" />
                    </div>
                  </Button>
                </Space>
              </Space>
            </Form.Item>
          </Form>
        </Spin>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  .ant-tabs-tab {
    padding-left: 0 !important;
  }
  .ant-form-item-label > label {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding-right: 1em;
  }
  .form-item-style {
    margin: 1em 0;
    width: 100%;
    max-width: 470px;
    margin-left: 40px;
    .ant-form-item-label {
      width: 315px;
      text-align: left;
    }
    .ant-form-item-control {
      .ant-form-item-control-input {
        .ant-form-item-control-input-content {
          .ant-select {
            max-width: 308px;
          }
        }
      }
    }
  }
  .lastItem {
    padding-top: 24px;
    .ant-form-item-control-input-content {
      display: grid;
      grid-template-columns: 0px auto;
      .ant-popover-buttons {
        .ant-btn {
          width: auto;
        }
      }
    }
  }
  .accountsSpace {
    margin-left: 40px;
    width: 100%;
    max-width: 470px;
    .ant-space-item {
      .ant-form-item {
        margin: 0;
      }
    }
  }

  .radioPadding {
    padding-left: 93px;
  }

  .radioContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 46px;
    .radioLabel {
      padding: 0 30px 0 0;
    }
    &.single {
      grid-gap: 140px;
    }
  }

  .ant-avatar-circle {
    margin-right: 1.1em;
    background: ${props => props.theme.color.purple["purple-3"]};
  }
  .stepHeader {
    width: 100%;
    font-weight: ${props => props.theme.text.bold};
    margin-top: 1em;
    margin-bottom: 1em;
    display: flex;
  }

  .step1 {
    padding-top: 24px;
  }

  .step2 {
    padding-top: 40px;
  }
`;

export default withTheme(injectIntl(Preferences));
